var Navigo = require('navigo');
var useHash = true;
var router = new Navigo(null, useHash);
var pageContentDiv = document.querySelector('.page-content');
var signInPageHTML = require('../signin.html');
var changePasswordPageHTML = require('../change-password.html');
var dashboardPageHTML = require('../dashboard.html');
var uploadBuildPageHTML = require('../upload-build.html');
var publishBuildPageHTML = require('../publish-build.html');
var uploadResource2FilesPageHTML = require('../upload-resource2.html');
var notificationPageHTML = require('../notification.html');
var pageNotFoundHTML = require('../404.html');

module.exports = { router: router };

var auth = require('./auth-handler');
var authHandler = auth.authHandler;
var logoutHandlerController = auth.logoutHandlerController;
var signinFormController = require('./signin-page').signinFormController;
var changePasswordFormController = require('./change-password-page').changePasswordFormController;
var firmwareListController = require('./dashboard-page').firmwareListController;
var uploadBuildFormController = require('./upload-build-page').uploadBuildFormController;
var uploadResource2Controller = require('./upload-resource2-page').uploadResource2FormController;
var publishBuildFormController = require('./publish-build-page').publishBuildFormController;
var notificationFormController = require('./notification-page').notificationFormController;

var swal = require('bootstrap-sweetalert');
swal.setDefaults({ animation: false });

router.on({
    '/signin': function () {
        loadPage('signin');
    },
    '/change-password': function () {
        loadPage('change-password');
    },
    '/dashboard': function () {
        loadPage('dashboard');
    },
    '/upload-build': function () {
        loadPage('upload-build');
    },
    '/publish-build': function () {
        loadPage('publish-build');
    },
    '/upload-resource2': function () {
        loadPage('upload-resource2');
    },
    '/notification': function() {
        loadPage('notification');
    }
});

router.on(function () {
    authHandler.init();
});

router.notFound(function () {
    loadPage('404');
});

router.resolve();

function loadPage(page) {
    switch (page) {
        case 'signin':
            document.title = 'Sign In';
            pageContentDiv.innerHTML = signInPageHTML;
            signinFormController.init();
            break;
        case 'change-password':
            document.title = 'Change Password';
            pageContentDiv.innerHTML = changePasswordPageHTML;
            changePasswordFormController.init();
            handleAuth();
            break;
        case 'dashboard':
            document.title = 'Dashboard';
            pageContentDiv.innerHTML = dashboardPageHTML;
            setActiveNavLink('dashboard');
            logoutHandlerController.init();
            firmwareListController.init();
            handleAuth(true);
            break;
        case 'upload-build':
            document.title = 'Upload Build';
            pageContentDiv.innerHTML = uploadBuildPageHTML;
            setActiveNavLink('upload-build');
            logoutHandlerController.init();
            uploadBuildFormController.init();
            handleAuth();
            break;
        case 'publish-build':
            document.title = 'Publish Build';
            pageContentDiv.innerHTML = publishBuildPageHTML;
            setActiveNavLink('publish-build');
            logoutHandlerController.init();
            publishBuildFormController.init();
            handleAuth(true);
            break;
        case 'upload-resource2':
            document.title = 'Upload Resource 2 Files';
            pageContentDiv.innerHTML = uploadResource2FilesPageHTML;
            setActiveNavLink('upload-resource2');
            logoutHandlerController.init();
            uploadResource2Controller.init();
            handleAuth();
            break;
        case 'notification':
            document.title = 'Edit Notification Text';
            pageContentDiv.innerHTML = notificationPageHTML;
            setActiveNavLink('notification');
            logoutHandlerController.init();
            notificationFormController.init();
            handleAuth(true);
            break;
        case '404':
            document.title = 'Page not found';
            pageContentDiv.innerHTML = pageNotFoundHTML;
            break;
        default:
            console.log('unexpected page');
    }
}

function handleAuth(dispatchS3Ready) {
    authHandler.init(dispatchS3Ready)
        .then(function () {
            // do nothing on success
        })
        .catch(function (error) {
            if (error !== 'authexpired') {
                swal('Session Error', error, 'error');
            }
            return false;
        });
}

function setActiveNavLink(page) {
    var navLinks = document.querySelector('[data-navigo]');
    for (var i = 0; i < navLinks.length; i++) {
        navLinks[i].className = '';
    }
    switch (page) {
        case 'dashboard':
            document.querySelector('a[href="/#/dashboard"]').className = 'active-nav-link';
            break;
        case 'upload-build':
            document.querySelector('a[href="/#/upload-build"]').className = 'active-nav-link';
            break;
        case 'upload-resource2':
            document.querySelector('a[href="/#/upload-resource2"]').className = 'active-nav-link';
            break;
        case 'publish-build':
            document.querySelector('a[href="/#/publish-build"]').className = 'active-nav-link';
            break;
        case 'notification':
            document.querySelector('a[href="/#/notification"]').className = 'active-nav-link';
            break;
        default:
            console.log('unexpected nav link');
    }
}
